/**
 * @file IconOrderEnter Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-order-enter',
  (data) => `
<svg width="${data.size}" height="${data.size}" fill="none" viewBox="0 0 16 16">
  <defs>
    <clipPath><rect width="16" height="16" x="0" y="0" rx="0" /></clipPath>
  </defs>
  <g clip-path="url(#master_svg0_1_00794/1_4215)">
    <g>
      <rect
        width="10.666666626930237"
        height="12.000000596046448"
        x="2.67"
        y="2"
        fill="none"
        stroke="${data.colorDesc[0]}"
        stroke-opacity="1"
        stroke-width="1.3333333730697632"
        rx="0"
      />
    </g>
    <g>
      <path
        fill="${data.colorDesc[0]}"
        fill-opacity="1"
        fill-rule="evenodd"
        d="M10.666581953125,6.0000410234375L5.333251953125,6.0000410234375L5.333251953125,4.6667070234375L10.666581953125,4.6667070234375L10.666581953125,6.0000410234375Z"
      />
    </g>
    <g>
      <path
        fill="${data.colorDesc[0]}"
        fill-opacity="1"
        fill-rule="evenodd"
        d="M10.666581953125,8.666667L5.333251953125,8.666667L5.333251953125,7.333333L10.666581953125,7.333333L10.666581953125,8.666667Z"
      />
    </g>
    <g>
      <path
        fill="${data.colorDesc[0]}"
        fill-opacity="1"
        fill-rule="evenodd"
        d="M9.333251953125,11.3332929765625L5.333251953125,11.3332929765625L5.333251953125,9.9999589765625L9.333251953125,9.9999589765625L9.333251953125,11.3332929765625Z"
      />
    </g>
  </g>
</svg>
`
);
